import React, { useMemo } from 'react';
import { WeekNote } from '@features/whereabouts/services/WeekNotesService';
import { UserAvatarAndName } from "@shared/ui/molecules/UserAvatarAndName";
import styled from "styled-components";
import Colours from "@shared/ui/atoms/Colours";
import { BodyRegular, BodyXXLSmall } from "@shared/ui/atoms/fonts/Body";
import { UsersWhereaboutsIconsRow } from "./UsersWhereaboutsIconsRow";
import moment from "moment";
import { DATE_FORMAT } from '@shared/utils/DateUtils';
import { useTranslation } from "react-i18next";
import { UsersDayNotesForTheWeek } from "./UsersDayNotesForTheWeek";
import { useSelector } from "react-redux";
import { selectCurrentUser } from '@shared/store/auth.duck';
import { smallTablet } from "@shared/ui/atoms/MediaQueries";

export function UsersWeekNote(props: Props) {
  const {weekNote} = props;
  const lastUpdated = useMemo(() => moment(weekNote.lastUpdated).format(DATE_FORMAT), [weekNote]);
  const {t} = useTranslation();
  const currentUser = useSelector(selectCurrentUser);

  return (
    <Row>
      <UserAvatarAndName firstName={weekNote.firstName} lastName={weekNote.lastName} hideName={true} colour={weekNote.userId === currentUser?.id ? 'darkBlue' : 'blue'} />
      <NoteBackground>
        <BodyRegular weight={400} style={{marginBottom: 10, whiteSpace: 'pre-wrap'}}>{weekNote.note}</BodyRegular>
        {weekNote.usersDayNotes && <UsersDayNotesForTheWeek dayNotes={weekNote.usersDayNotes} whereabouts={weekNote.whereabouts} />}
        <UsersWhereaboutsIconsRow whereabouts={weekNote.whereabouts} />
        <LastUpdated>
          <BodyXXLSmall colour={Colours.darkGrey}>{t('dialog.week-note-last-updated', {lastUpdated: lastUpdated})}</BodyXXLSmall>
        </LastUpdated>
      </NoteBackground>
    </Row>
  )
}

interface Props {
  weekNote: WeekNote;
}

const NoteBackground = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 16px 24px;
  background-color: ${Colours.veryLightGrey};
  border-radius: 12px;
  margin-left: 16px;
  position: relative;
`

const LastUpdated = styled.div`
  right: 16px;
  bottom: 8px;
  @media (${smallTablet}) {
    position: absolute;
  }
`

const Row = styled.div`
  display: flex;
  margin-bottom: 8px;
  .userAvatarAndName {
    align-items: flex-start;
    margin-top: 16px;
  }
`

